import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { RoleEnum } from '@core/enums/role.enum';
import { userSelector } from '@core/store/user/user-selector';
import { AppStoreState } from '@interfaces/app-store-state';

@Injectable({
  providedIn: 'root'
})
export class FormalistGuard implements CanActivate {
  private readonly store = inject<Store<AppStoreState>>(Store);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.isUserFormalist();
  }

  private isUserFormalist(): Observable<boolean> {
    return this.store.select(userSelector).pipe(
      filter(user => !!user),
      take(1),
      map(user => {
        if (user.roles.includes(RoleEnum.roleFormalist)) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
